(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9440],{

/***/ 44961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94951);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50866);
/* harmony import */ var _components_Register_Register__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32749);
/* harmony import */ var _hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85683);
/* harmony import */ var _ui_Content_Content__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74920);
/* harmony import */ var _utils_url_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8333);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40238);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);













var Register = function Register() {
  var _useTranslation = (0,_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
      title: t('seo.registration.title'),
      description: t('seo.registration.description'),
      noindex: !_constants__WEBPACK_IMPORTED_MODULE_8__/* .IS_PROD */ .XK,
      nofollow: !_constants__WEBPACK_IMPORTED_MODULE_8__/* .IS_PROD */ .XK,
      openGraph: {
        images: [{
          url: "https://profivzdelavanie.sk".concat((0,_utils_url_utils__WEBPACK_IMPORTED_MODULE_7__/* .publicAssets */ .VK)('/og-konferencia.png'))
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_ui_Content_Content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_Register_Register__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Register);

/***/ }),

/***/ 88374:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registracia",
      function () {
        return __webpack_require__(44961);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,4623,2749,9774,2888,179], function() { return __webpack_exec__(88374); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);